import { gql } from "lib/apolloClient";

export const courseOverviewCountFragments = {
  elementSetCoverageCount: gql`
    fragment elementSetCoverageCount on GenericYearlyInsightPlannerElementSetCoverage {
      type
      leafNodeCount
      plannerElementNode {
        id
        isLeaf
        associatedParents {
          id
        }
      }
    }
  `,
};
